import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { type BaseApiResponse, onApiError, useVToast } from '@/package';

const ERROR_TOAST_DURATION = 1000;
const DEFAULT_TOAST_PARAM = {
  autoClose: true,
  duration: ERROR_TOAST_DURATION,
  variant: 'error',
} as const;

export const useApiErrorHandler = () => {
  const { addToast } = useVToast();
  const { t } = useTranslation();

  useEffect(() => {
    const unsubscribe = onApiError(event => {
      const { resultCode } = event.target as BaseApiResponse;
      const option: Parameters<typeof addToast>[0] = {
        message: '',
        ...DEFAULT_TOAST_PARAM,
      };

      switch (resultCode) {
        default:
          option.message = t('error.defaultError.coperiodic');
          break;
      }

      option.message && addToast(option);
    });

    return unsubscribe;
  }, []);
};
